import React, {useEffect, useState} from 'react';
import {goToPage, resetCgIframeUrl, createTouristESim} from '../touristESimBlockSlice';
import {connect} from 'react-redux';
import CGPayment from '../../../Shared/CGPayment/CGPayment';
import {cgMidTypeEnum} from '../../../../utilities/enums/cgTypeEnum';

const PaymentPage = (props) => {
  const [isDisplayErrorPopup, setIsDisplayErrorPopup] = useState(false);
  const [errorPopupContent, setErrorPopupContent] = useState('');

  const [paymentInfo, setPaymentInfo] = useState('');
  const [esim, setEsim] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [qrCode, setQrCode] = useState('');

  useEffect(() => {
    console.log('PaymentInfo', paymentInfo.authNumber);
    //  props.createTouristESim({paymentInfo});
    if (paymentInfo && paymentInfo != '') {
      let resulrEsim = props.createTouristESim({paymentInfo});
      if (true) {
        setEsim('');
        setPhoneNumber('');
        setQrCode('');
        // props.goToPage('esimScanPage');
      }
    }
  }, [paymentInfo]);

  const handleResult = async (data) => {};
  return (
    <div className='slideAnimation'>
      {/* <div className='title'>sssss</div> */}
      <CGPayment
        cgMidType={cgMidTypeEnum.saleJet}
        totalPrice={12}
        identity={12}
        setPaymentInfo={setPaymentInfo}
        handleResult={handleResult}
        source="TouristESimBlock"
      />
    </div>
  );

  function closePopUp() {
    setIsDisplayErrorPopup(false);
  }
  function onclickTryAgainBtn() {
    getCgUrl();
    setIsDisplayErrorPopup(false);
  }

  function handlePageContinue() {
    props.goToPage('createSaleInProcess');
    props.reportDWH({actionType: 'Credit Card Info', status: 'Ongoing', messageText: 'Credit Card Info Button Clicked'});
    /*
    if (isTermsCheckboxChecked) {
      props.goToPage('createSaleInProcess');
      props.reportDWH({ actionType: 'Credit Card Info', status: 'Ongoing', messageText: 'Credit Card Info Button Clicked' });
    }
    else {
      setIsDisplayCheckboxErrorMsg(true);
    }
    */
  }

  function handleSubmit(event) {
    event.preventDefault();
  }
};
const mapStateToProps = (state) => {
  return {
    iframeUrl: state.touristESimBlock.paymentInfo.iframeUrl,
    //other states
  };
};
const mapDispatchToProps = {
  goToPage,
  resetCgIframeUrl,
  createTouristESim,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentPage);
